import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { SUBSCRIPTION_COPY } from "../../CONSTANTS/APPCONSTANTS";
import { ONBOARDING_BILLING_PLAN } from "../../navigation/CONSTANTS";
import { getShopifyAppInstallationUrl } from "../../utils/shopifyAdminUrls";
import "./NoActiveSubscriptionModal.css";

/*
 * isOpen is computed once in App.js (via useNoActiveSubscription) and passed
 * down here, rather than this component checking the subscription itself —
 * RouterConfig needs that same boolean to skip mounting data-heavy pages
 * (Forecasting, Account, etc.) while this modal is shown, and computing it
 * twice would mean two separate getCurrentBillingPlan() calls.
 */
const NoActiveSubscriptionModal = ({ isOpen }) => {
  const history = useHistory();
  const { userDetails } = useSelector((state) => state.user);

  const choosePlan = () => {
    history.push(ONBOARDING_BILLING_PLAN);
  };

  const uninstallApp = () => {
    const url = getShopifyAppInstallationUrl(userDetails?.shop_name);
    if (!url) {
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="noActiveSubscriptionOverlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="noActiveSubscriptionTitle"
    >
      <div className="noActiveSubscriptionCard">
        <h2 id="noActiveSubscriptionTitle" className="noActiveSubscriptionTitle">
          {SUBSCRIPTION_COPY.inactiveTitle}
        </h2>
        <p className="noActiveSubscriptionBody">
          {SUBSCRIPTION_COPY.inactiveBody}
        </p>
        <div className="noActiveSubscriptionActions">
          <button type="button" className="choosePlanBtn" onClick={choosePlan}>
            {SUBSCRIPTION_COPY.choosePlan}
          </button>
          <button type="button" className="uninstallBtn" onClick={uninstallApp}>
            {SUBSCRIPTION_COPY.uninstall}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoActiveSubscriptionModal;
